import { MATURITY, NATURE, SEVERITY } from "@/lib/api";
import { t } from "@/lib/i18n";

const pill = (m, testId) => (
  <span data-testid={testId} className="inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap"
    style={{ background: m.bg, color: m.text, borderColor: m.border }}>
    {t(m.label)}
  </span>
);

export const MaturityBadge = ({ maturity }) => (MATURITY[maturity] ? pill(MATURITY[maturity], `maturity-badge-${maturity}`) : null);
export const NatureBadge = ({ nature }) => (NATURE[nature] ? pill(NATURE[nature], `nature-badge-${nature}`) : null);

export const SeverityBadge = ({ severity }) => {
  const s = SEVERITY[severity] || SEVERITY.promemoria;
  return (
    <span data-testid={`severity-badge-${severity}`} className="inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider"
      style={{ borderColor: s.color, color: s.color, background: `${s.color}1A` }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.color }} />
      {t(s.label)}
    </span>
  );
};

export const PageHeader = ({ eyebrow, title, subtitle, children }) => (
  <header className="px-5 lg:px-8 pt-6 lg:pt-8 pb-5 border-b border-border fade-up">
    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
      <div>
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h1 className="text-2xl lg:text-4xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {children}
    </div>
  </header>
);

export const Stat = ({ label, value, hint, accent, testId }) => (
  <div data-testid={testId} className="surface p-4 flex flex-col gap-1">
    <span className="eyebrow">{label}</span>
    <span className="num text-2xl lg:text-3xl font-semibold" style={accent ? { color: accent } : undefined}>{value}</span>
    {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
  </div>
);
